import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { checkSession, logout } from "../utils/api"; // ✅ use backend session check
import AdminNavbar from "./AdminNavbar";

function AdminDashboard() {
  const [role, setRole] = useState(null);
  const [username, setUsername] = useState("");
  const [loading, setLoading] = useState(true);

  const navigate = useNavigate();

  useEffect(() => {
    // ✅ Check backend session
    checkSession()
      .then((res) => {
        if (!res.loggedIn) {
          navigate("/login");
        } else {
          setRole(res.role);
          // ✅ Fix: use res.username directly
          setUsername(res.username || "");
        }
      })
      .catch((err) => {
        console.error("Session check failed:", err);
        navigate("/login");
      })
      .finally(() => setLoading(false));
  }, [navigate]);

  const handleLogout = async () => {
    await logout(); // ✅ clear backend session
    sessionStorage.clear(); // optional local cleanup
    navigate("/login");
  };

  if (loading) {
    return <p className="text-muted">Checking session...</p>;
  }

  if (!role) {
    return <p>Please log in to access the dashboard.</p>;
  }

  return (
    <div>
      <AdminNavbar onLogout={handleLogout} />
      <div className="admin-dashboard container mt-4">
        <h2>Welcome {username || "Admin"}!</h2>
        <p className="text-muted">Role: {role}</p>

        {role === "admin" ? (
          <div className="row mt-4">
            <div className="col-md-4 col-sm-12 mb-3">
              <div className="card shadow-sm">
                <div className="card-body">
                  <h5 className="card-title">Manage Properties</h5>
                  <p className="card-text">
                    Add, edit, or remove property listings.
                  </p>
                </div>
              </div>
            </div>

            <div className="col-md-4 col-sm-12 mb-3">
              <div className="card shadow-sm">
                <div className="card-body">
                  <h5 className="card-title">Manage Users</h5>
                  <p className="card-text">
                    Create accounts, assign roles, reset passwords.
                  </p>
                </div>
              </div>
            </div>

            {/* Future: System Logs card */}
          </div>
        ) : (
          <div className="mt-4">
            <h4>User Dashboard</h4>
            <p>You can browse properties but do not have admin privileges.</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default AdminDashboard;
